import { useLoaderData } from 'react-router'

export const meta = () => [{ title: 'About Us | EBHS' }]

interface StaffMember {
	name: string
	position?: string
	email?: string
}

interface Trustee {
	name: string
	position?: string
}

export function loader() {
	const staff: StaffMember[] = [
		{
			position: 'Academy Chronicles',
			name: 'Julie Jugle',
			email: 'ebhsnewsletter@ebhs1838.org',
		},
		{
			name: 'Dianne Crowley',
			position: 'Membership',
			email: 'membership@ebhs1838.org',
		},
		{ name: 'Mollie Knapp', position: 'Collections' },
		{
			name: 'Barb Hunt',
			position: 'Genealogy',
			email: 'Barb.Hunt@ebhs1838.org',
		},
		{
			name: 'Caroline MacMillen',
			position: 'Genealogy',
			email: 'Carol.MacMillen@ebhs1838.org',
		},
		{
			name: 'Judi Stewart',
			position: 'Historian',
			email: 'Judi.Stewart@ebhs1838.org',
		},
		{
			name: 'Mathieu Steele',
			position: 'Webmaster',
			email: 'matt@steeleagency.com',
		},
	]
	const trustees: Trustee[] = [
		{ name: 'Karen Conners' },
		{ name: 'Kathy Cooper', position: 'Treasurer' },
		{ name: 'Peg Gochenaur', position: 'President' },
		{
			name: 'Barbara Henderson',
			position: '1st Vice President and Correspondence',
		},
		{ name: 'Bob Howard' },
		{ name: 'Julie Jugle' },
		{ name: 'Mollie Knapp' },
		{ name: 'Shari Marianacci', position: 'Recording Secretary' },
		{ name: 'Jeffery Peacock' },
		{ name: 'Quintin Peacock' },
		{ name: 'Judi Stewart', position: 'Town Historian' },
		{ name: 'Robin Stewart' },
		{ name: 'Sarah Williams' },
	]
	return { staff, trustees }
}

export default function About() {
	const { staff, trustees } = useLoaderData<typeof loader>()

	return (
		<>
			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h1 className="text-4xl leading-tight font-bold text-gray-900">
						About Us
					</h1>
				</div>
			</header>

			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl leading-tight font-bold text-gray-900">
						Staff
					</h2>
				</div>
			</header>
			<div className="pt-4 pb-8">
				<div className="mx-auto max-w-6xl sm:px-6 lg:px-8">
					<div className="overflow-hidden bg-white shadow sm:rounded-lg">
						<div className="border-gray-200 px-4 py-5 sm:px-6">
							<h3 className="text-lg leading-6 font-medium text-gray-900">
								With the exception of the office coordinator position, all staff
								members are volunteers.
							</h3>
						</div>
						<div className="px-4 py-5 sm:p-0">
							<dl>
								{staff.map((person, index) => (
									<div
										className="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
										key={index}
									>
										<dd className="text-xl leading-5 font-medium text-gray-500">
											{person.position}
										</dd>
										<dt className="mt-1 text-xl leading-5 text-gray-900 sm:mt-0">
											{person.name}
										</dt>
										<dt className="mt-1 text-xl leading-5 text-gray-900 sm:mt-0">
											{person.email ? (
												<a
													href={'mailto:' + person.email}
													className="font-medium text-blue-700 transition duration-150 ease-in-out hover:text-blue-500"
												>
													{person.email}
												</a>
											) : null}
										</dt>
									</div>
								))}
							</dl>
						</div>
					</div>
				</div>
			</div>

			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl leading-tight font-bold text-gray-900">
						Trustees
					</h2>
				</div>
			</header>
			<div className="px-4 pt-4 pb-8">
				<div className="mx-auto max-w-6xl sm:px-6 lg:px-8">
					<div className="overflow-hidden bg-white shadow sm:rounded-lg">
						<div className="px-4 py-5 sm:p-0">
							<dl>
								{trustees.map((trustee, index) => (
									<div
										className="mt-8 sm:mt-0 sm:grid sm:grid-cols-2 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
										key={index}
									>
										<dd className="text-xl leading-5 font-medium text-gray-500">
											{trustee.position}
										</dd>
										<dt className="mt-1 text-xl leading-5 text-gray-900 sm:mt-0">
											{trustee.name}
										</dt>
									</div>
								))}
							</dl>
						</div>
					</div>

					<header className="py-4">
						<h2 className="text-3xl leading-tight font-bold text-gray-900">
							Board Meetings
						</h2>
					</header>

					<p className="py-4 text-lg">
						All society members are welcome to attend our monthly board meetings
						that are held at the Academy Museum, 8 South Avenue, East
						Bloomfield. The board meets the first Monday of each month at 4:30
						P.M. If the regular meeting day should fall on a holiday the meeting
						will be scheduled for an alternate date.
					</p>

					<p className="py-4 text-lg">
						If interested in serving on the board, please contact our office
						coordinator at 585-657-7244.
					</p>

					{/* <p className="py-4 text-lg">
						Agendas &amp; Minutes from Past Board Meetings
					</p>

					<ul className="rounded-md border border-gray-200 bg-white">
						{[
							{
								month: '2020 January',
								agenda:
									'https://ebhs1838.s3.amazonaws.com/2020-01-06-ebhs-agenda.pdf',
								minutes:
									'https://ebhs1838.s3.amazonaws.com/2020-01-06-ebhs-minutes.pdf',
							},
							{
								month: '2020 February',
								agenda:
									'https://ebhs1838.s3.amazonaws.com/2020-02-03-ebhs-agenda.pdf',
								minutes:
									'https://ebhs1838.s3.amazonaws.com/2020-02-03-ebhs-minutes.pdf',
							},
							{
								month: '2020 March',
								agenda:
									'https://ebhs1838.s3.amazonaws.com/2020-03-02-ebhs-agenda.pdf',
								minutes:
									'https://ebhs1838.s3.amazonaws.com/2020-03-02-ebhs-minutes.pdf',
							},
							{
								month: '2020 June',
								agenda:
									'https://ebhs1838.s3.amazonaws.com/2020-06-01-ebhs-agenda.pdf',
								minutes:
									'https://ebhs1838.s3.amazonaws.com/2020-06-01-ebhs-minutes.pdf',
							},
							{
								month: '2020 July',
								agenda:
									'https://ebhs1838.s3.amazonaws.com/2020-07-06-ebhs-agenda.pdf',
								minutes:
									'https://ebhs1838.s3.amazonaws.com/2020-07-06-ebhs-minutes.pdf',
							},
							{
								month: '2020 August',
								agenda:
									'https://ebhs1838.s3.amazonaws.com/2020-08-03-ebhs-agenda.pdf',
								minutes:
									'https://ebhs1838.s3.amazonaws.com/2020-08-03-ebhs-minutes.pdf',
							},
							{
								month: '2020 September',
								agenda:
									'https://ebhs1838.s3.amazonaws.com/2020-09-08-ebhs-agenda.pdf',
								minutes:
									'https://ebhs1838.s3.amazonaws.com/2020-09-08-ebhs-minutes.pdf',
							},
							{
								month: '2020 October',
								agenda:
									'https://ebhs1838.s3.amazonaws.com/2020-10-05-ebhs-agenda.pdf',
								minutes: null,
							},
						].map((meeting, index) => (
							<li
								key={meeting.month}
								className={[
									'flex items-center justify-between py-6 pr-8 pl-6 text-2xl leading-5',
									index > 0 ? 'border-t border-gray-200' : '',
								].join(' ')}
							>
								<div className="flex w-0 flex-1 items-center">
									<span className="ml-2">{meeting.month}</span>
								</div>
								<div className="ml-4 shrink-0">
									<a
										href={meeting.agenda}
										className="font-medium text-blue-800 transition duration-150 ease-in-out hover:text-blue-500"
									>
										Agenda
									</a>
									{'    '}
									{meeting.minutes ? (
										<a
											href={meeting.minutes}
											className="font-medium text-blue-800 transition duration-150 ease-in-out hover:text-blue-500"
										>
											Minutes
										</a>
									) : null}
								</div>
							</li>
						))}
					</ul>
					<ul className="mt-4 rounded-md border border-gray-200 bg-white">
						<li className="flex items-center justify-between py-3 pr-4 pl-3 text-xl leading-5">
							<div className="flex w-0 flex-1 items-center">
								<span className="ml-2 w-0 flex-1 truncate">
									<a
										href="https://ebhs1838.s3.amazonaws.com/2020-in-review.pdf"
										className="leading-normal font-medium text-blue-800 transition duration-150 ease-in-out hover:text-blue-500"
									>
										2020 Annual Report
									</a>
								</span>
							</div>
						</li>
					</ul> */}
				</div>
			</div>
		</>
	)
}
